import * as React from 'react';
import { Button } from '@ixicare/ui';
import { type LucideIcon } from 'lucide-react';
import styles from './GenericTable.module.css';

interface Props {
  label: string;
  lucide?: LucideIcon;
  title?: string;
  onClick: () => void;
}

/**
 * A labelled action for a table toolbar.
 *
 * The shared Button so it looks like every other button in the app, resized to the toolbar's
 * 32px row — it is built for form footers, where 48px and a 120px minimum are right.
 *
 * Lives here rather than in the calling module so the toolbar keeps ownership of how its own row
 * looks, and callers cannot drift from it.
 */
export const ToolbarAction: React.FC<Props> = ({ label, lucide, title, onClick }) => (
  <Button
    type="button"
    className={styles.ToolbarAction}
    buttonType="primary-flat"
    lucide={lucide}
    onClick={onClick}
    title={title ?? label}
  >
    {label}
  </Button>
);
